import React from 'react';
import styles from './index.less';


interface ITitleProps {
  title?: string;
  type?: 'little' | 'horizontal';
}
const Title: React.FC<ITitleProps> = ({ title, type }) => {
  if (type === 'little') {
    return (
      <div className={styles.littleTitle}>
        <span>{title}</span>
      </div>
    );
  }
  if (type === 'horizontal') {
    return <div className={styles.horizontalTitle}><span>{title}</span></div>;
  }
  return (
    <div className={styles.title}>
      <div className={styles.icon} />
      <span>{title}</span>
    </div>
  );
};

export default Title;
